export default __webpack_public_path__ + "static/media/bw_photos_tuscany-2.bda098b9.jpg";